/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, DatePicker, Form } from 'antd'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import Checkbox from '../../components/Custom/CustomCheckbox'
import ContituentSelect from '../../components/Custom/ConstituentSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedComplainants: [{
				complainant_index: 1
			}],
			selectedRespondents: [{
				respondent_index: 1
			}],
			selectedRespondent: null,
			didSelectRespondent: false,
			selectedComplainant: null,
			didSelectComplainant: false,
			isComplainantResident: false,
			isRespondentResident: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedBlotter, form } = this.props
		const { setFieldsValue } = form
		if (selectedBlotter) {
			const complainants = selectedBlotter.complainants.map((i, key) => Object.assign({}, i, { complainant_index: (key+1) }))
			const respondents = selectedBlotter.respondents.map((i, key) => Object.assign({}, i, { respondent_index: (key+1) }))
			this.setState({
				selectedComplainants: complainants,
				selectedRespondents: respondents
			}, () => {
				complainants.map(i => {
					setFieldsValue({
						[`is_complainant_resident_${i.complainant_index}`]: !_.isNull(i.complainant_ref_uid),
						[`complainant_name_${i.complainant_index}`]: i.complainant_name,
						[`complainant_address_${i.complainant_index}`]: i.complainant_address
					})
				})
				respondents.map(i => {
					setFieldsValue({
						[`is_respondent_resident_${i.respondent_index}`]: !_.isNull(i.respondent_ref_uid),
						[`respondent_name_${i.respondent_index}`]: i.respondent_name,
						[`respondent_address_${i.respondent_index}`]: i.respondent_address
					})
				})
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		let { selectedRespondents, selectedComplainants } = this.state
		const { history, form, AuthStore, saveBlotter, onClose, isEdit, selectedBlotter } = this.props
		const { barangay_uid, barangay_term_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			selectedComplainants = selectedComplainants.map(selectedComplainant => {
				const selectedConstituent = this.state[`selectedComplainant${selectedComplainant.complainant_index}`]
				const isResident = values[`is_complainant_resident_${selectedComplainant.complainant_index}`] || false
				const complainant_name = (selectedConstituent && isResident) ? `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}` :
					values[`complainant_name_${selectedComplainant.complainant_index}`]
				const complainant_ref_uid = (selectedConstituent && isResident) ? selectedConstituent.uid : null
				const complainant_address = (selectedConstituent && isResident) ? `${selectedConstituent.house_no || ''} ${selectedConstituent.street || ''} ${selectedConstituent.address || ''} - ${selectedConstituent.purok_name}` : 
					values[`complainant_address_${selectedComplainant.complainant_index}`]
				return {
					...selectedComplainant,
					isComplainantResident: isResident,
					complainant_name,
					complainant_ref_uid,
					complainant_address
				}
			})

			selectedRespondents = selectedRespondents.map(selectedRespondent => {
				const selectedConstituent = this.state[`selectedRespondent${selectedRespondent.respondent_index}`]
				const isResident = values[`is_respondent_resident_${selectedRespondent.respondent_index}`] || false
				const respondent_name = (selectedConstituent && isResident) ? `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}` :
					values[`respondent_name_${selectedRespondent.respondent_index}`]
				const respondent_ref_uid = (selectedConstituent && isResident) ? selectedConstituent.uid : null
				const respondent_address = (selectedConstituent && isResident) ? `${selectedConstituent.house_no || ''} ${selectedConstituent.street || ''} ${selectedConstituent.address || ''} - ${selectedConstituent.purok_name}` : 
					values[`respondent_address_${selectedRespondent.respondent_index}`]
				return {
					...selectedRespondent,
					isRespondentResident: isResident,
					respondent_name,
					respondent_ref_uid,
					respondent_address
				}
			})

			let params = Object.assign({}, values, {
				barangay_uid,
				barangay_term_uid,
				complainants: selectedComplainants,
				respondents: selectedRespondents
			})
			if (isEdit && selectedBlotter) {
				params = Object.assign({}, params, { blotter_uid: selectedBlotter.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_brgy_blotter', content: 'Saving Blotter, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBlotter(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_blotter', content: 'Blotter successfully saved.' })

					if (isEdit && selectedBlotter) {
						//create audit trail
						const auditParams = {
							module_name: 'Blotter',
							action: 'Update',
							message: 'Update blotter record'
						}
						AuthStore.saveAuditTrail(auditParams)
					} else {
						//create audit trail
						const auditParams = {
							module_name: 'Blotter',
							action: 'Create',
							message: 'Created new blotter record'
						}
						AuthStore.saveAuditTrail(auditParams)
					}

					// const { uid } = response.data.setBlotter
					// history.push({ pathname: `/blotter/details/${uid}` })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay blotter')
					message.error({ key: 'set_brgy_blotter', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedBlotter, AuthStore } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid } = AuthStore
		const { 
			isSaving, selectedComplainants, selectedRespondents
		} = this.state
        
		return (
			<Drawer
				title="Add New Blotter"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'75%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<legend>Complainant</legend>
							{
								selectedComplainants.map((i, key) => (
									<Row key={key} style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
										<Row style={{ marginBottom: -35 }}>
											<Form.Item label=''>
												{ getFieldDecorator(`is_complainant_resident_${i.complainant_index}`, {
													//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
													rules: [{
														required: false,
														message: 'This field is required.'
													}, {
														validator: (rule, value, callback) => {
															if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																callback('only white space detected.')
															}
															callback()
														}
													}]
												})
												(
													<Checkbox 
														style={{ color: 'red' }}
													>Is complainant {i.complainant_index} Resident?
													</Checkbox>
												)}
											</Form.Item>
										</Row>
										{
											(getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedBlotter && getFieldValue(`is_complainant_resident_${i.complainant_index}`) && !_.isNull(selectedBlotter.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_name_${i.complainant_index}`, {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<ContituentSelect
															barangay_uid={barangay_uid}
															placeholder='Select Complainant name'
															onSelectedItem={(item) => {
																this.setState({ [`selectedComplainant${i.complainant_index}`]: Object.assign({}, item, { didSelectComplainant: true }) })
															}}
														/>
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedBlotter && !getFieldValue(`is_complainant_resident_${i.complainant_index}`) && _.isNull(selectedBlotter.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_name_${i.complainant_index}`, {
														initialValue: (selectedBlotter) ? selectedBlotter.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Complainant name' />
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_complainant_resident_${i.complainant_index}`) || 
											(selectedBlotter && !getFieldValue(`is_complainant_resident_${i.complainant_index}`) && _.isNull(selectedBlotter.complainant_ref_uid))) &&
											<Row>
												<Form.Item label={`Complainant Address ${i.complainant_index}`}>
													{ getFieldDecorator(`complainant_address_${i.complainant_index}`, {
														initialValue: (selectedBlotter) ? selectedBlotter.complainant_address : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Complainant address' />
													)}
												</Form.Item>
											</Row>
										}
										{
											((key > 0) && ((key + 1) == (selectedComplainants.length))) &&
											<Row type='flex' justify='center'>
												<a 
													style={{ color: 'red' }}
													onClick={() => {
														selectedComplainants.splice(key)
														this.setState({ selectedComplainants })
													}}
												>Delete</a>
											</Row>
										}
									</Row>
								))
							}
							<Row type='flex' justify='center'>
								<a 
									style={{ color: 'blue' }}
									onClick={() => {
										const newComplainant = { complainant_index: (selectedComplainants.length + 1) }
										selectedComplainants.push(newComplainant)
										this.setState({ selectedComplainants })
									}}
								>+ Add Complainant</a>
							</Row>
						</Col>
						<Col md={12} sm={24}>
							<legend>Respondent</legend>
							{
								selectedRespondents.map((i, key) => (
									<Row key={key} style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
										<Row style={{ marginBottom: -35 }}>
											<Form.Item label=''>
												{ getFieldDecorator(`is_respondent_resident_${i.respondent_index}`, {
													//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
													rules: [{
														required: false,
														message: 'This field is required.'
													}, {
														validator: (rule, value, callback) => {
															if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																callback('only white space detected.')
															}
															callback()
														}
													}]
												})
												(
													<Checkbox 
														style={{ color: 'red' }}
													>Is respondent {i.respondent_index} Resident?
													</Checkbox>
												)}
											</Form.Item>
										</Row>
										{
											(getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedBlotter && getFieldValue(`is_respondent_resident_${i.respondent_index}`) && !_.isNull(selectedBlotter.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_name_${i.respondent_index}`, {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<ContituentSelect
															barangay_uid={barangay_uid}
															placeholder='Select Respondent name'
															onSelectedItem={(item) => {
																this.setState({ [`selectedRespondent${i.respondent_index}`]: Object.assign({}, item, { didSelectRespondent: true }) })
															}}
														/>
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedBlotter && !getFieldValue(`is_respondent_resident_${i.respondent_index}`) && _.isNull(selectedBlotter.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_name_${i.respondent_index}`, {
														initialValue: (selectedBlotter) ? selectedBlotter.respondent_name : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Respondent name' />
													)}
												</Form.Item>
											</Row>
										}
										{
											(!getFieldValue(`is_respondent_resident_${i.respondent_index}`) || 
											(selectedBlotter && !getFieldValue(`is_respondent_resident_${i.respondent_index}`) && _.isNull(selectedBlotter.respondent_ref_uid))) &&
											<Row>
												<Form.Item label={`Respondent Address ${i.respondent_index}`}>
													{ getFieldDecorator(`respondent_address_${i.respondent_index}`, {
														initialValue: (selectedBlotter) ? selectedBlotter.respondent_address : null,
														rules: [{
															required: true,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input placeholder='Enter Respondent address' />
													)}
												</Form.Item>
											</Row>
										}
										{
											((key > 0) && ((key + 1) == (selectedRespondents.length))) &&
											<Row type='flex' justify='center'>
												<a 
													style={{ color: 'red' }}
													onClick={() => {
														selectedRespondents.splice(key)
														this.setState({ selectedRespondents })
													}}
												>Delete</a>
											</Row>
										}
									</Row>
								))
							}
							<Row type='flex' justify='center'>
								<a 
									style={{ color: 'blue' }}
									onClick={() => {
										const newRespondent = { respondent_index: (selectedRespondents.length + 1) }
										selectedRespondents.push(newRespondent)
										this.setState({ selectedRespondents })
									}}
								>+ Add Respondent</a>
							</Row>
						</Col>
					</Row>
					<legend>Details</legend>
					<Row>
						<Form.Item label='Date filed'>
							{ getFieldDecorator('complain_date', {
								initialValue: (selectedBlotter) ? moment(selectedBlotter.complain_date) : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<DatePicker format='LLL' showTime style={{ width: '100%' }}/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: (selectedBlotter) ? selectedBlotter.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={8} placeholder='Enter Blotter remarks' />
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_BLOTTER = gql`
    mutation setBlotter($input: JSON) {
		setBlotter(input: $input)
    }
`

const composed = compose(
	withRouter,
	Form.create({ name: 'form-barangay-blotter' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_BLOTTER, {
		props({ mutate }) {
			return {
				saveBlotter(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains','barangayBlotters']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
